// src/com/plan_stat/TransPlanStateForDc.js
import React, { useState, useEffect } from 'react';
// import { styled  } from '@mui/material/styles';
import { Box } from '@mui/system';
import { TopContainer, TopHeader, TopContent, ControlLine, NoDataBox } from '../../common/TopStyle';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import VzmDateField from '../../common/VzmDateField';
import IsValid from '../../value/IsValid';
import { useLazyQuery, useReactiveVar } from '@apollo/client';
import { bulkCompanyProductsListRepo, transPlanAndActorListRepo, transPlanStateForDcParamRepo, transPlanTsrItemRepo, userInfoRepo } from '../../value/AppModel';
import { LIST_TRANS_PLAN_AND_ACTOR_FROM_MOBILE } from '../trans_plan_and_actor/TransPlanAndActorGql';
import { AppObject, AppStyle, AppWord, TopCode } from '../../value/AppConst';
import { useAlertSetter } from '../../api/app-hook';
import { Button, MenuItem, Select } from '@mui/material';
import TransPlanStateForDcLine from './TransPlanStateForDcLine';
import { GET_TRANS_PLAN_TSR } from '../tsr/TransPlanTsrGql';
import TransPlanStateForDcView from './TransPlanStateForDcView';
import SearchBox from '../../common/SearchBox';
import { LIST_BULK_COMPANY_PRODUCTS } from '../bulk_company_products/BulkCompanyProductsGql';
import TransPlanTsrGroup from '../tsr/TransPlanTsrGroup';

const TsrAll = 'all';
const TsrNo = 'no';
const TsrYes = 'yes';

const TsrIssueOptions = [
    {value: TsrAll, label: 'TSR 발행 무관'},
    {value: TsrNo, label: 'TSR 미발행'},
    {value: TsrYes, label: 'TSR 발행'},
];
/**
 * 배차현황. 모바일에서는 운송사와 센터 모두 동일한 UI.
 * @returns 
 */
export default function TransPlanStateForDc() {
    const sessionInfo = useReactiveVar(userInfoRepo);
    const [records, setRecords] = useState([]);
    const transPlanStateForDcParam = useReactiveVar(transPlanStateForDcParamRepo);
    const transPlanAndActorListData = useReactiveVar(transPlanAndActorListRepo);
    const bulkCompanyProductsListData = useReactiveVar(bulkCompanyProductsListRepo);
    const [indexSelected, setIndexSelected] = useState(-1);
    const [plan, setPlan] = useState(null);
    const [searchText, setSearchText] = useState('');
    const [sortInfo, setSortInfo] = useState({id: null, order: 0}); // -1 : descending, 0: no sorting, 1: ascending
    const [tsrOption, setTsrOption] = useState(TsrAll);
    const [openTsrDetail, setOpenTsrDetail] = useState(false);
    const addAlert = useAlertSetter();

    const [getTransPlanAndActorList, responseList] = useLazyQuery(LIST_TRANS_PLAN_AND_ACTOR_FROM_MOBILE, {
        ...AppObject.NoCachedFetch,
        onCompleted: (data, option) => {onCompleteGetList(data, option)},
		onError: (error) => addAlert({title: '배차현황 조회 오류', message: [error.message]})
    });
    const [getTransPlanTsrItem, responsePlanItem] = useLazyQuery(GET_TRANS_PLAN_TSR, {
		...AppObject.NoCachedFetch,
		onCompleted: (data, option) => {onCompleteGetPlanItem(data, option)},
		onError: (error) => addAlert({title: "배차정보 조회 오류", message: [error.message]})
	});
    // 982 Bulk 상품 목록 조회
    const [getBulkCompanyProductsList, responseBulkCompanyProductsList] = useLazyQuery(LIST_BULK_COMPANY_PRODUCTS, {
        ...AppObject.NoCachedFetch,
        onCompleted: (data, option) => {onCompleteGetBulkCompanyProductsList(data, option)},
		onError: (error) => addAlert({title: '벌크상품 목록 조회 오류', message: [error.message]})
    });

    const getTransPlanAndActorListNow = (planDate) => {
        const param = {variables:{planDate}};
        getTransPlanAndActorList(param);
        // setDurationChanged(false);
    };

    const getBulkCompanyProductsListNow = () => {
        const diff = new Date().getTime()/1000 - bulkCompanyProductsListData.when;
        if(diff > 3600) {
            getBulkCompanyProductsList({variables:{bulkCompanyId:null, bulkProductsId:null}});
        }
    };

    useEffect(()=>{
        if(IsValid.date(transPlanStateForDcParam.planDate)) {
            getTransPlanAndActorListNow(transPlanStateForDcParam.planDate);
        }
    }, [transPlanStateForDcParam]);

    useEffect(() => {
        let list;
        if(tsrOption === TsrAll) list = transPlanAndActorListData.records;
        else {
            list = transPlanAndActorListData.records.filter((item) => {
                if(tsrOption === TsrYes) return item.reqStateFlag === '2';
                else return item.reqStateFlag !== '2';
            });
        }
        if(searchText && searchText.trim().length > 0) {
            const txt = searchText.trim();
            list = list.filter((item) => {
                return item.storeName.includes(txt) ||
                (item.vehPlates && item.vehPlates.includes(txt)) ||
                (item.driverName && item.driverName.includes(txt)) ||
                (item.vehTypeName && item.vehTypeName.includes(txt));
            });
            /* setRecords(list.filter((item) => {
                return item.storeName.includes(txt) ||
                (item.vehPlates && item.vehPlates.includes(txt)) ||
                (item.driverName && item.driverName.includes(txt)) ||
                (item.vehTypeName && item.vehTypeName.includes(txt));
            })); */
        }
        // else setRecords(list);
        if(sortInfo.id && sortInfo.order !== 0) {
            const newList = [...list].sort((a, b) => {
                const orderBy = sortInfo.order < 0 ? -1 : 1; // -1: descending, 1: ascending
                if(a[sortInfo.id] < b[sortInfo.id]) return -1 * orderBy;
                if(a[sortInfo.id] > b[sortInfo.id]) return orderBy;
                return 0;
            });
            list = newList;
        }
        setRecords(list);
    }, [searchText, tsrOption, transPlanAndActorListData, sortInfo]);

    // 982 Bulk 상품 목록 조회
    useEffect(()=>{
        if(sessionInfo.user.getDcCd() === TopCode.DcCode.Adc982) {
            getBulkCompanyProductsListNow();
        }
    }, [sessionInfo]);

    // >>>>>>>>> callbacks <<<<<<<<<<<<<
    const onCompleteGetList = (data, clientOption) => {
        if(data.transPlanAndActorListFromMobile) {
            const newData = {...transPlanAndActorListData};
            newData.when = new Date().getTime()/1000;
            newData.records = data.transPlanAndActorListFromMobile;
            transPlanAndActorListRepo(newData);
            setIndexSelected(-1);
            setPlan(null);
        }
    };

    const onCompleteGetPlanItem = (data, option) => {
        if(data.transPlanTsrItem) {
            setPlan(data.transPlanTsrItem);
            transPlanTsrItemRepo(data.transPlanTsrItem); // 상차상세내역, 물류집기 뷰를 위해서
        }
        else addAlert({title:"배차정보 조회", message:['지정한 배차정보를 찾을 수 없습니다.']});
    };

    // 982 Bulk 상품 목록 조회
    const onCompleteGetBulkCompanyProductsList = (data, clientOption) => {
        // console.log(">>> onCompleteGetList <<<");
        if(data.bulkCompanyProductsList) {
            bulkCompanyProductsListRepo({when:new Date().getTime()/1000, records:data.bulkCompanyProductsList});
        }
    };

    const onChangePlanDate = (id, value) => {
        transPlanStateForDcParamRepo({planDate: value});
    };

    const onClickGetList = () => {
        if(IsValid.date(transPlanStateForDcParam.planDate)) {
            getTransPlanAndActorListNow(transPlanStateForDcParam.planDate);
        }
        else alert('출고일자를 선택하세요');
    };

    const onClickItem = (item, index) => {
        getTransPlanTsrItem({variables:{planId:item.planId}});
        setIndexSelected(index);
    };

    const onClickCloseDetail = () => {
        setIndexSelected(-1);
        // setPlan(null);
    };

    const onChangeSearchText = (text) => {
        setSearchText(text);
    };

    const onClickOpenTsr = (item) => {
        // 데이터는 이미 transPlanTsrItemRepo에 들어가 있음.
        setOpenTsrDetail(true);
    };

    const onClickSorter = (id, sortState) => {
        setSortInfo({id, order: sortState});
    };

    const onCompleteTakingOverCargo = () => {
        // 점포에서 인수 후 다시 조회
        if(plan) getTransPlanTsrItem({variables:{planId:plan.planId}});
    }
    
    const loadingAny
    = responseList.loading
    || responsePlanItem.loading
    || responseBulkCompanyProductsList.loading;

    return(
        <TopContainer>
            <TopHeader>
                배차현황
            </TopHeader>
            <ControlLine>
                <VzmDateField
                    dict={{
                        id: 'planDate',
                        label: '출고일자'
                    }}
                    value={transPlanStateForDcParam.planDate || ''}
                    error={!IsValid.date(transPlanStateForDcParam.planDate)}
                    onChange={onChangePlanDate}
                />
                <Button
                    variant={AppStyle.mui.contained}
                    color={AppStyle.mui.primary}
                    size={AppWord.SMALL}
                    startIcon={<CloudDownloadIcon />}
                    style={{marginLeft: 10}}
                    onClick={onClickGetList}
                    disabled={loadingAny}
                >
                    조회
                </Button>
            </ControlLine>
            <ControlLine>
                <SearchBox
                    value={searchText}
                    onChangeText={onChangeSearchText}
                    disabled={responseList.loading}
                />
                <Select
                    value={tsrOption}
                    onChange={(e) => {setTsrOption(e.target.value)}}
                    size={AppWord.SMALL}
                    style={{marginLeft: 10}}
                >
                    {
                        TsrIssueOptions.map((item) => {
                            return(
                                <MenuItem
                                    key={item.value}
                                    value={item.value}
                                    style={{fontSize:'0.85rem', whiteSpace:'nowrap'}}
                                >
                                    {item.label}
                                </MenuItem>
                            )
                        })
                    }
                </Select>
            </ControlLine>
            <TransPlanStateForDcLine
                onClickSorter={onClickSorter}
                idSorted={sortInfo.id}
            />
            <TopContent style={{borderTop: '1px solid #ddd'}}>
                {
                    records.length === 0 ?
                    <NoDataBox />
                    :    
                    <Box>
                        {
                            records.map((item, index) => {
                                if(indexSelected === index && Boolean(plan) && plan.planId === item.planId) {
                                    return(
                                        <TransPlanStateForDcView
                                            key={index}
                                            item={plan}
                                            onClickOpenTsr={onClickOpenTsr}
                                            onClose={onClickCloseDetail}
                                        />
                                    );
                                }
                                return(
                                    <TransPlanStateForDcLine
                                        key={index}
                                        item={item}
                                        index={index}
                                        indexSelected={indexSelected}
                                        onClick={onClickItem}
                                    />
                                )
                            })
                        }
                    </Box>}
            </TopContent>
            <TransPlanTsrGroup
                open={openTsrDetail}
                onClose={()=>setOpenTsrDetail(false)}
                onCompleteTakingOverCargo={onCompleteTakingOverCargo}
            />
        </TopContainer>
    );
}
